import React, { ReactElement } from 'react';
import {
    EmbeddedLoginAuthenticating as EmbeddedLoginAuthenticatingCore,
    EmbeddedLoginAuthenticatingProps,
} from '@instinet-analytics/semantic-ui-components';
import { useDispatchSupportRequestAction } from 'app/contactSupport/store/dispatcher';

export default function EmbeddedLoginAuthenticating(
    props: EmbeddedLoginAuthenticatingProps
): ReactElement {
    const dispatchSupportRequest = useDispatchSupportRequestAction();

    return (
        <EmbeddedLoginAuthenticatingCore
            {...props}
            onContactSupportClicked={dispatchSupportRequest}
        />
    );
}
